import(/* webpackMode: "eager" */ "/app/src/app/[lang]/terms-and-conditions/loading.tsx");
